import { ProductType } from '@/shared/enums';
import Banner from './banners/banner';
import Banners from './banners/banners';
import Category from './categories/category';
import Clip from './clip/clip';
import Channel from './live/channel';
import Channels from './live/channels';
import Episode from './series/episode';
import Episodes from './series/episodes';
import Section from './sections/section';
import Program from './live/program';
import Programs from './live/programs';
import Serial from './series/serial';
import Series from './series/series';
import Vod from './vods/vod';
import Vods from './vods/vods';
import Special from './special';

export default {
  [ProductType.BANNER]: Banner,
  [ProductType.BANNERS]: Banners,
  [ProductType.CATEGORY]: Category,
  [ProductType.CLIP]: Clip,
  [ProductType.EPISODE]: Episode,
  [ProductType.EPISODES]: Episodes,
  [ProductType.LIVE]: Channel,
  [ProductType.LIVES]: Channels,
  [ProductType.PROGRAMME]: Program,
  [ProductType.PROGRAMMES]: Programs,
  [ProductType.SERIAL]: Serial,
  [ProductType.SERIES]: Series,
  [ProductType.VOD]: Vod,
  [ProductType.VODS]: Vods,
  [ProductType.TIMESHIFT]: Special,
  [ProductType.SECTION]: Section,
  [ProductType.N_PVR]: Special,
  [ProductType.CATCH_UP]: Special,
  [ProductType.DOWNLOAD]: Special,
};
